import { TextFilterType } from '../../../../../types';
import { InvoiceProcessingJobStatuses } from '../../../../../main/invoiceProcessingJobs/invoiceProcessingJobsTypes';

export type UniversalFilterInvoiceProcessingJobStatusStatus =
  InvoiceProcessingJobStatuses;

export const enum UniversalFilterInvoiceProcessingJobStatusModes {
  IS_ANY_OF = 'is_any_of',
  IS_NONE_OF = 'is_none_of'
}

export type UniversalFilterInvoiceProcessingJobStatusValue = TextFilterType;

export type UniversalFilterInvoiceProcessingJobStatusFilterState = {
  mode: UniversalFilterInvoiceProcessingJobStatusModes;
  statuses?: UniversalFilterInvoiceProcessingJobStatusStatus[];
};

export type UniversalFilterInvoiceProcessingJobStatusOnFilterStateChange = (
  state: UniversalFilterInvoiceProcessingJobStatusFilterState
) => void;

export type UniversalFilterInvoiceProcessingJobStatusOnChange = (
  value?: UniversalFilterInvoiceProcessingJobStatusValue
) => void;

export type UniversalFilterInvoiceProcessingJobStatusFilterOptions = {
  availableStatuses: UniversalFilterInvoiceProcessingJobStatusStatus[];
};
